/**
 * OfflineBanner - Shows when the user loses internet connection
 * Auto-hides when back online
 */

import { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setWasOffline(true);
    };
    const handleOnline = () => {
      setIsOffline(false);
      // Show "back online" briefly
      setTimeout(() => setWasOffline(false), 3000);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline && !wasOffline) return null;

  if (!isOffline && wasOffline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[60] bg-green-500 text-white text-center py-2 text-sm font-medium animate-slide-down">
        Connexion retablie
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-orange-500 text-white text-center py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium animate-slide-down">
      <WifiOff className="w-4 h-4" />
      <span>Vous etes hors ligne</span>
      <button
        onClick={() => window.location.reload()}
        className="ml-2 px-2 py-0.5 bg-white/20 rounded text-xs font-semibold flex items-center gap-1"
      >
        <RefreshCw className="w-3 h-3" />
        Reessayer
      </button>
    </div>
  );
}
